import { AxiosError } from 'axios';

import {
  ACCOUNT_SURVEY_UPDATE_FAILURE,
  ACCOUNT_SURVEY_UPDATE_REQUEST,
  ACCOUNT_SURVEY_UPDATE_SUCCESS,
} from '@app/store/actionTypes';

interface UpdateSurvey {
  category: string;
  department: string;
  name: string;
  phoneNumber: string;
  scale: string;
  type: string;
}

export function updateSurvey({
  category,
  department,
  name,
  phoneNumber,
  scale,
  type,
}: UpdateSurvey) {
  return {
    type: ACCOUNT_SURVEY_UPDATE_REQUEST,
    payload: {
      category,
      department,
      name,
      phoneNumber,
      scale,
      type,
    },
  };
}

export function updateSurveySuccess() {
  return {
    type: ACCOUNT_SURVEY_UPDATE_SUCCESS,
  };
}

export function updateSurveyFailure(error: AxiosError) {
  return {
    type: ACCOUNT_SURVEY_UPDATE_FAILURE,
    payload: error,
    error: true,
  };
}

export type AccountSurveyAction =
  | ReturnType<typeof updateSurvey>
  | ReturnType<typeof updateSurveySuccess>
  | ReturnType<typeof updateSurveyFailure>;
